import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getSwiperList() {
  return request({
    url: '/swiper/getSwiperDate',
    params: {
    }
  })
}

export function getSwiperById(swiperId) {
  return request({
    url: '/swiper/getSwiperById',
    params: {
      swiperId:swiperId
    }
  })
}

export function delBySwiperId(id) {
  return requestMsg({
    url: '/swiper/delBySwiperId',
    params: {
      swiperId: id,
    }
  })
}

export function addSwiperByActive(swiper) {
  return requestMsg({
    url: '/swiper/addSwiperByActive',
    data: JSON.stringify(swiper),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
